import "./styles.scss";

import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { handleSelectColor } from "../../../utils/utils";

const CardLevelAndCycle = ({ openModalSelectLevelStudent }) => {
  const { t } = useTranslation();
  const { report, currentCycleAndLevelStudent } = useSelector((state) => state.methodologyReducer);

  const isDemoOrFirstClass =
    report[0]?.classSchedule?.classScheduleDetails[0]?.focus === "demo class" || report[0]?.checkIfFirstClass;

  return (
    <div className={`wrapperLevel ${isDemoOrFirstClass && "mb_30"}`}>
      {currentCycleAndLevelStudent?.length === 0 && (
        <button className="buttonSelectLevelStudent" onClick={openModalSelectLevelStudent}>
          {t("SELECT_STUDENT_LEVEL")}
        </button>
      )}

      {isDemoOrFirstClass && currentCycleAndLevelStudent?.length !== 0 && (
        <div className="wrapperCardLevelAndCycle" onClick={openModalSelectLevelStudent}>
          <div className="cycles">
            <p>{t("LEVEL")}</p>
            <div className={`circle ${handleSelectColor(currentCycleAndLevelStudent[0]?.level)}`}>
              {currentCycleAndLevelStudent[0]?.level}
            </div>
          </div>

          <div className="levels">
            <p>{t("CYCLE")}</p>
            <div className={`circle ${handleSelectColor(currentCycleAndLevelStudent[0]?.level)}`}>
              {currentCycleAndLevelStudent[0]?.contentCycle}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardLevelAndCycle;
